import { render, staticRenderFns } from "./CalculatorMainSection.vue?vue&type=template&id=5be1629c&scoped=true"
import script from "./CalculatorMainSection.vue?vue&type=script&lang=ts"
export * from "./CalculatorMainSection.vue?vue&type=script&lang=ts"
import style0 from "./CalculatorMainSection.vue?vue&type=style&index=0&id=5be1629c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be1629c",
  null
  
)

export default component.exports